import { DEFAULT_EMAIL_TEMPLATE_LIMIT, DEFAULT_POLICY_LIMIT } from '../planMap';
export var StripeProducts;
(function (StripeProducts) {
    StripeProducts["Essentials"] = "essentials";
    StripeProducts["Pro"] = "pro";
    StripeProducts["OrgAddOn"] = "org_add_on";
})(StripeProducts || (StripeProducts = {}));
export var StripePricesLookupKeys;
(function (StripePricesLookupKeys) {
    StripePricesLookupKeys["Essentials50"] = "essentials-50";
    StripePricesLookupKeys["Essentials150"] = "essentials-150";
    StripePricesLookupKeys["Pro300"] = "pro-300";
    StripePricesLookupKeys["Pro600"] = "pro-600";
    StripePricesLookupKeys["Pro1000"] = "pro-1000";
    StripePricesLookupKeys["Pro2000"] = "pro-2000";
    StripePricesLookupKeys["OrgAddOn"] = "org-share";
    StripePricesLookupKeys["OriginalSMS"] = "original-sms";
    /** Wallet topup */
    StripePricesLookupKeys["WalletTopUp"] = "wallet-topup";
})(StripePricesLookupKeys || (StripePricesLookupKeys = {}));
export const plansV3 = {
    [StripeProducts.Essentials]: {
        name: `Essentials`,
        description: `Everything to automate late fees, discounts & more`,
        features: {
            webhooks: false,
            whitelabel: false,
            customDomain: false,
            multicurrency: false,
            statementInterest: true,
            statementEmails: true,
        },
        addOns: [],
        prices: {
            [StripePricesLookupKeys.Essentials50]: {
                name: `Essentials 50`,
                previouslyNamed: `Mini`,
                description: `50 invoices + 250 emails each month.`,
                lookupKey: StripePricesLookupKeys.Essentials50,
                currency: `USD`,
                default: true,
                limits: {
                    actions: 25,
                    emails: 250,
                    invoices: 50,
                    contacts: 200,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                },
            },
            [StripePricesLookupKeys.Essentials150]: {
                name: `Essentials 150`,
                previouslyNamed: `Starter`,
                description: `150 invoices + 600 emails each month.`,
                lookupKey: StripePricesLookupKeys.Essentials150,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 50,
                    emails: 600,
                    invoices: 150,
                    contacts: 400,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                },
            },
        },
    },
    [StripeProducts.Pro]: {
        name: `Pro`,
        description: `Everything in Essentials, plus statement interest, custom domains & more. Better value for higher volumes.`,
        features: {
            webhooks: true,
            whitelabel: true,
            customDomain: true,
            multicurrency: true,
            statementInterest: true,
            statementEmails: true,
        },
        addOns: [StripePricesLookupKeys.OrgAddOn],
        prices: {
            [StripePricesLookupKeys.Pro300]: {
                name: `Pro 300`,
                previouslyNamed: `Professional`,
                description: `Access to all Paidnice features.`,
                lookupKey: StripePricesLookupKeys.Pro300,
                currency: `USD`,
                default: true,
                limits: {
                    actions: 100,
                    emails: 1200,
                    invoices: 300,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                },
            },
            [StripePricesLookupKeys.Pro600]: {
                name: `Pro 600`,
                previouslyNamed: `Multi`,
                description: `Access to all Paidnice features. 600 invoices + 1800 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro600,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 200,
                    emails: 1800,
                    invoices: 600,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                },
            },
            [StripePricesLookupKeys.Pro1000]: {
                name: `Pro 1000`,
                description: `Access to all Paidnice features. 1000 invoices + 4000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro1000,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 400,
                    emails: 4000,
                    invoices: 1000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                },
            },
            [StripePricesLookupKeys.Pro2000]: {
                name: `Pro 2000`,
                previouslyNamed: `Multi +`,
                description: `Access to all Paidnice features. 2000 invoices + 8000 emails each month.`,
                lookupKey: StripePricesLookupKeys.Pro2000,
                currency: `USD`,
                default: false,
                limits: {
                    actions: 800,
                    emails: 8000,
                    invoices: 2000,
                    contacts: 1000,
                    policies: DEFAULT_POLICY_LIMIT,
                    emailTemplates: DEFAULT_EMAIL_TEMPLATE_LIMIT,
                },
            },
        },
    },
};
export function findPlanByLookupKey(lookupKey) {
    const plan = Object.values(plansV3).find(plan => {
        return Object.values(plan.prices).find(price => price.lookupKey === lookupKey);
    });
    return plan;
}
export function findPriceByLookupKey(lookupKey) {
    const plan = findPlanByLookupKey(lookupKey);
    if (!plan) {
        return null;
    }
    return plan.prices[lookupKey];
}
//# sourceMappingURL=stripeConfig.js.map